import papa from 'papaparse';
import xlsx from 'xlsx';

const handleXLSXFile = (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise(function handlePromise(resolve, reject) {
    reader.onload = (e: ProgressEvent<FileReader>) => {
      if (!e.target || !e.target.result) {
        reject(new Error('Event target or result is null'));
        return;
      }
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = xlsx.read(data, { type: 'array', WTF: true });

      if (!(workbook as any).Strings) {
        reject(new Error('Workbook has no strings'));
        return;
      }
      const cells = (workbook as any).Strings.map((item: any) => item.t);
      resolve(cells.join());
    };

    reader.onerror = () => {
      reader.abort();
      reject();
    };

    reader.readAsArrayBuffer(file);
  });
};

const handleCSVFile = (file: File): Promise<string> => {
  let cells: any[] = [];

  return new Promise<string>((resolve, reject) => {
    const onComplete = (results: papa.ParseResult<any>) => {
      const nonDelimitorErrors = results.errors.filter((error) => error.type !== 'Delimiter');

      if (nonDelimitorErrors.length) {
        reject(new Error('CSV Parse error'));
        return;
      }

      results.data.forEach((item: any) => {
        cells = cells.concat(item);
      });

      resolve(cells.join());
    };

    papa.parse(file, { complete: onComplete });
  });
};

const handleTXTFile = (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise<string>((resolve, reject) => {
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject();
        return;
      }

      try {
        decodeURIComponent(result);
      } catch {
        reject();
        return;
      }

      resolve(result);
    };

    reader.onerror = () => {
      reader.abort();
      reject();
    };

    reader.readAsText(file);
  });
};

export const handleFileSheet = (file: File): Promise<string> => {
  const ext = file.name.split('.').pop();

  switch (ext) {
    case 'csv':
      return handleCSVFile(file);
    case 'txt':
      return handleTXTFile(file);
    case 'xlsx':
      return handleXLSXFile(file);
    default:
      return Promise.reject(new Error('Unsupported file type'));
  }
};
